@if (sesion.header == 1) {
<div class="header fixed-top scrolled" [ngClass]="{'secundary': !scroll, 'no-color' : noColor}">
  <nav class="navbar navbar-expand-md container-fluid">
    @if (dataLogHea.logo == 1) {
    <div class="logo">
      @if (sesion.path == 'campaign' || sesion.path == 'campaign,estado') {
      <a class="navbar-brand" title="Logo Midatacrédito">
        <img class="icon" src="assets/icons/v2/logo_midc_white.svg" alt="Logo Midatacrédito" title="Logo Midatacrédito">
      </a>
      }
      @if (sesion.path != 'campaign' && sesion.path != 'campaign,estado') {
      <a class="navbar-brand" (click)="direccionar_logo()" title="Logo Midatacrédito">
        <img class="icon" src="assets/icons/v2/logo_midc_white.svg" alt="Logo Midatacrédito"
          title="Logo Midatacrédito" />
      </a>
      }
    </div>
    }
    @if (dataLogHea.logo == undefined || dataLogHea.logo != 1) {
    <div class="logo">
      @if (sesion.path == 'campaign' || sesion.path == 'campaign,estado' ) {
      <a class="navbar-brand" title="Logo Midatacrédito">
        <img class="icon d-none d-md-block" src="assets/icons/new/logo_negativo_old.svg"
          alt="midatacredito datacredito ofertas de credito" title="Logo Midatacrédito" />
        <img class="icon d-block d-md-none head-mobile" src="assets/icons/v2/logo_midc_white.svg"
          alt="midatacredito datacredito ofertas de credito" title="Logo Midatacrédito" />
      </a>
      }
      @if (sesion.path != 'campaign' && sesion.path != 'campaign,estado' ) {
      <a class="navbar-brand" (click)="direccionar_logo()" title="Logo Midatacrédito">
        <img class="icon d-none d-md-block" src="assets/icons/new/logo_negativo_old.svg"
          alt="midatacredito datacredito ofertas de credito" title="Logo Midatacrédito" />
        @if (!sesion.sesionCookie) {
        <img class="icon d-block d-md-none head-mobile" src="assets/icons/v2/logo_midc_white.svg"
          alt="midatacredito datacredito ofertas de credito" title="Logo Midatacrédito" />
        }
        @if (sesion.sesionCookie) {
        <img class="icon d-block d-md-none" src="assets/icons/new/logo_negativo_old.svg"
          alt="midatacredito datacredito ofertas de credito" title="Logo Midatacrédito" />
        }
      </a>
      }
    </div>
    }
    <div class="collapse navbar-collapse">
      <ul class="navbar-nav align-center">
        @for (cat of categorias; track cat; let i = $index) {
        <div class="{{cat.url}}">
          @if (cat.state == 1) {
          <li class="nav-item {{cat.url}}">
            <div class="btn-group dropCategory {{cat.url}}">
              @if (cat.subcategories != 0) {
              <button type="button" class="nav-link dropdown-toggle {{cat.url}}" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false" id="{{cat.url}}" (click)="direccionar(cat.url)">
                {{cat.name}}
              </button>
              }
              @if (cat.subcategories == 0) {
              <button type="button" class="nav-link dropdown-toggle {{cat.url}}" id="{{cat.url}}"
                (click)="direccionar(cat.url)">
                {{cat.name}}
              </button>
              }
              @if (cat.subcategories != 0) {
              <div class="dropdown-menu iDropCategory" [ngStyle]="{'margin-left': styleDrop[i]}">
                <div class="contUp" (click)="direccionar(cat.url)">
                  <i class="arrowUp"></i>
                </div>
                <ul [ngStyle]="{'column-count': styleCols[i]}">
                  @for (sub of cat.subcategories; track sub) {
                  <div class="{{sub.url}}">
                    @if (sub.state == 1) {
                    <li (click)="direccionar(cat.url+'/'+sub.url)" id="{{sub.url}}" class="{{sub.url}}"><img
                        src="{{sub.iconD}}" alt="{{sub.name}}" appLazyLoadImg class="iconCategory {{sub.url}}" /><span
                        class="{{sub.url}}">{{sub.name}}</span></li>
                    }
                  </div>
                  }
                </ul>
              </div>
              }
            </div>
          </li>
          }
        </div>
        }
        @if (!sesion.sesionCookie && (sesion.path != 'campaign' && sesion.path != 'campaign,estado' )) {
        <li class="nav-item border-left">
          <a class="nav-link btn-mrkt btn-outline-white border-r-18 bgc-green p-light" title="Registro Buscacrédito"
            (click)="redirectLogin()">
            <span>Ingresar </span>
            <!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
          </a>
        </li>
        }
        @if (sesion.sesionCookie && initial && (sesion.path != 'campaign' && sesion.path != 'campaign,estado')) {
        <li class="nav-item dropdown mr-4">
          <a class="nav-link dropdown-toggle btn-mrkt btn-outline-white border-r-18 p-light" href="#"
            title="Nombre usuario" id="necesitas" role="button" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false" (click)="envio_datalayer_header('Menú usuario | Buscacrédito')">
            <span>Hola, {{this.nameSesion}}</span>
            <i class="fa fa-chevron-down" aria-hidden="true"></i>
          </a>
          <div class="dropdown-menu" aria-labelledby="necesitas">
            <a class="dropdown-item" routerLink="/perfil-bc/mis-aplicaciones" title="Mis aplicaciones"
              (click)="envio_datalayer_header('Mis aplicaciones | Menú usuario')">
              <i class="fa fa-bell-o" aria-hidden="true"></i>
              <span>Mis aplicaciones</span>
            </a>
            <a class="dropdown-item" href="{{profileUrl}}" rel="noopener" title="Perfil Buscacrédito"
              (click)="envio_datalayer_header('Perfil | Menú usuario')">
              <i class="fa fa-user-o" aria-hidden="true"></i>
              <span>Perfil</span>
            </a>
            <a class="dropdown-item" (click)="cerrarSesion()" title="Cerrar sesión">
              <i class="fa fa-sign-out" aria-hidden="true"></i>
              <span>Salir</span>
            </a>
          </div>
        </li>
        }
      </ul>
    </div>
    <!-- Collapse button -->
    <div style="display: flex;">
      @if (!sesion.sesionCookie) {
      <button class="btn-login-mobile d-block d-md-none" (click)="redirectLogin(true)">Ingresar</button>
      }
      @if (sesion.path != 'campaign' && sesion.path != 'campaign,estado' ) {
      <button class="navbar-toggler first-button" (click)="toggleClass()" type="button" data-toggle="collapse"
        data-target="#navbarSupportedContent20" aria-controls="navbarSupportedContent20" aria-expanded="false"
        aria-label="Toggle navigation">
        <div [class.open]="isOpen" class="animated-icon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
      }
    </div>
  </nav>
</div>
}
@if (isOpen) {
<div class="submenu position-fixed">
  <div class="submenu-top">
    <div class="submenu-logo">
      <div class="row">
        <a class="brand-mob" title="Logo Midatacrédito">
          @if (!sesion.sesionCookie) {
          <img src="assets/icons/v2/logo_midc_white.svg" class="icon" alt="midatacredito datacredito ofertas de credito"
            title="Logo Midatacrédito" />
          }
          @if (sesion.sesionCookie) {
          <img src="assets/icons/new/logo_negativo_old.svg" class="icon big-log"
            alt="midatacredito datacredito ofertas de credito" title="Logo Midatacrédito" />
          }
        </a>
        <div class="cta-close">
          <button class="close" aria-label="Close" (click)="toggleClass()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
    <div class="list-group list-group-flush">
      <!-- sesion -->
      <!-- no sesion-->
      @if (!sesion.sesionCookie) {
      <div>
        <a class="list-group-item bgc-green" (click)="redirectLogin()" title="Registrate">Ingresar<i
            class="fa fa-chevron-right"></i></a>
      </div>
      }
      @if (sesion.sesionCookie) {
      <div>
        <a class="list-group-item no-color" routerLink="/perfil-bc/mis-aplicaciones" title="Mis aplicaciones"
          (click)="toggleClass()"><i class="fa fa-search" aria-hidden="true"></i>Mis aplicaciones</a>
        <a class="list-group-item no-color" href="{{profileUrl}}" rel="noopener" title="Perfil" (click)="toggleClass()">
          <i class="fa fa-user-o" aria-hidden="true"></i>Perfil</a>
      </div>
      }
      <div class="category" id="category">
        <ul>
          <hr class="separador">
          @for (cat of categorias; track cat) {
          <div>
            @if (cat.state == 1) {
            <li class="">
              @if (cat.subcategories != 0) {
              <button class="btn btn-link {{cat.url}}_m" data-toggle="collapse" attr.data-target="#{{cat.name}}"
                aria-expanded="false" attr.aria-controls="{{cat.name}}">
                {{cat.name}}
              </button>
              }
              @if (cat.subcategories == 0) {
              <button class="btn btn-link {{cat.url}}_m" (click)="direccionar(cat.url)" (click)="toggleClass()">
                {{cat.name}}
              </button>
              }
              <div id="{{cat.name}}" class="collapse no-color" data-parent="#category">
                <ul class="itemCategory">
                  @for (sub of cat.subcategories; track sub) {
                  <div class="{{sub.url}}_m">
                    @if (sub.state == 1) {
                    <li (click)="direccionar(cat.url+'/'+sub.url)" (click)="toggleClass()" class="{{sub.url}}_m"><img
                        src="{{sub.iconM}}" alt="" class="iconCategory" class="{{sub.url}}_m" /><span
                        class="{{sub.url}}_m">{{sub.name}}</span></li>
                    }
                  </div>
                  }
                </ul>
              </div>
            </li>
            }
          </div>
          }
        </ul>
      </div>
      @if (sesion.sesionCookie) {
      <a class="list-group-item bgc-green" (click)="cerrarSesion(); toggleClass()" title="Salir">Salir</a>
      }
    </div>
  </div>
</div>
}